import {get} from "lodash"
import getLimits from "@irati/deals/utils/deal/limits"
import {Deal, Product} from "@irati/types"
import ProductTypes from "../../../../constants/productTypes"

export default function getDealType(deal: Deal) {
  const products: Product[] = get(deal, "productConfig.products", null)
  if (!deal || !products) {
    return null
  }

  const limits = getLimits(deal)
  const noAttachedProducts = get(deal, "productConfig.products", 0) === 0 ? 0 : deal.productConfig.products.length

  if (get(deal, "isBirthdayBox", false)) {
    return ProductTypes.BIRTHDAY_BOX
  } else if (limits.numProducts === 1 && noAttachedProducts > 1) {
    const isCinema =
      products.filter((prod) => {
        return get(prod, "data.cinemaMetadata.enabled", false)
      }).length > 0
    if (isCinema) {
      return ProductTypes.CINEMA
    } else if (noAttachedProducts === 1 && limits.numItems === 1) {
      return false
    } else if (noAttachedProducts > 1 && limits.numItems === 1) {
      // drop down
      return ProductTypes.SINGLE_PRODUCT
    }
    // drop down + quantity selector
    return ProductTypes.SINGLE_PRODUCT_QUANTITY
  } else if (limits.minOpenValuePrice && limits.maxOpenValuePrice) {
    return ProductTypes.OPEN_VALUE_PRODUCT
  } else if (limits.numProducts === 1 && noAttachedProducts === 1) {
    // single product no drop down, displays same as multiple
    return ProductTypes.MULTIPLE_PRODUCTS
  } else if (limits.numProducts > 1 || !limits.numProducts || !limits.numItems) {
    return ProductTypes.MULTIPLE_PRODUCTS
  }
  return null
}
